import {
  ApplicationFeature,
  FileMetaDataDto,
  FormBaseType,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_REPORTS_METADATA = "GET_REPORTS_METADATA";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

interface GetReportsMetadataRequest {
  formBaseType: FormBaseType;
  relatedFeature: ApplicationFeature;
}

export const getReportsMetadata = async (
  params: GetReportsMetadataRequest,
): Promise<FileMetaDataDto[]> => {
  const response = await formsApi.formsControllerGetReportsMetaData(
    [params.formBaseType.toString()],
    params.relatedFeature,
  );

  return response.data;
};

export const useGetReportsMetadata = (
  user: UserProfileDto | null,
  params: GetReportsMetadataRequest,
): {
  reportsMetadata?: FileMetaDataDto[];
  reportsMetadataEnabled: boolean;
  isLoadingReports: boolean;
  isFetchingReports: boolean;
  isSuccessReports: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isLoading, isFetching, isSuccess } = useQuery({
    queryKey: [DOMAIN_FORMS, ACTION_GET_REPORTS_METADATA, params],
    queryFn: () => getReportsMetadata(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    reportsMetadata: data,
    reportsMetadataEnabled: enabled,
    isLoadingReports: isLoading,
    isFetchingReports: isFetching,
    isSuccessReports: isSuccess,
  };
};
